import { computed, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  state = signal<Map<string, any>>(new Map());
  cartState = computed(() => this.state());
  activationPrice = signal<string>('');

  resetCart() {
    this.state.set(new Map());
  }

  updateCart<T>(product: T | null, disc: string) {
    this.state.update((current) => {
      const map = new Map(current);

      if (!product) {
        map.delete(disc);
      } else {
        map.set(disc, product);
      }

      return map;
    });
  }
}
